/* eslint-disable @typescript-eslint/no-explicit-any*/

import {
  CASHBACK_BALANCE,
  CASHBACK_DETAILS,
  CASHBACK_REPORT,
  CASHBACK_BALANCE_MONEY,
} from '@portal/actions/actionTypes';

const initialState: reducers.CashbackReducer = {
  detail: null,
  report: null,
  balance: null,
  moneyReport: null,
};

const cashbackReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case CASHBACK_DETAILS:
      state = {
        ...state,
        detail: action.payload,
      };
      break;

    case CASHBACK_REPORT:
      state = {
        ...state,
        report: action.payload.rows,
      };
      break;

    case CASHBACK_BALANCE:
      state = {
        ...state,
        balance: action.payload.balance,
      };
      break;

    case CASHBACK_BALANCE_MONEY:
      state = {
        ...state,
        moneyReport: action.payload.rows,
      };
      break;

    default:
      return state;
  }

  return state;
};

export default cashbackReducer;
